<template>
<div class="kb-gallery-bar" :class="{'kb-gallery-bar--active': active}">
  <div class="kb-gallery-bar__indicator-bar" :style="`animation-duration: ${duration/1000}s;`" :class="{'paused': paused, 'hideIndicator': hideIndicator}"></div>
</div>
</template>

<script>
export default{
  name: 'kb-gallery-bar',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    paused: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number
    },
    hideIndicator: {
      type: Boolean
    }
  }
}
</script>

<style lang="scss">
@import '../../../scss/colors';

.kb-gallery-bar {
  background-color: rgba(255, 255, 255, .5);
  height: 3px;
  width: 100%;
  border-radius: 4px;

  &--active {
    background-color: #fff;

    & > div {
      animation-name: indicatorAnimation;
      animation-fill-mode: forwards;
      animation-iteration-count: 1;
      animation-timing-function: linear;

      &.paused {
        animation-play-state:paused;
      }
    }
  }

  &__indicator-bar {
    background-color: $primary;
    display: block;
    height: 3px;
    width: 0%;

    &.hideIndicator {
      display: none;
    }
  }
}

@keyframes indicatorAnimation {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
</style>